export const enterpriseFeaturesKeyMapperHandler = (auth) => {
    if (Object.keys(auth).length && auth?.enterpriseFeaturesDto) {
      return {
        enterpriseFeatureDto: {
          companyId: auth?.companyId,
          usDotManagementenabled: auth?.enterpriseFeaturesDto['US_DOT_MANAGEMENT'],
          chatEnabled: auth?.enterpriseFeaturesDto['CHAT'],
          bulkDownloadEnabled: auth?.enterpriseFeaturesDto['BULK_DOWNLOAD'],
          nonVehicleEnabled: auth?.enterpriseFeaturesDto['NON_VEHICLE'],
          dotTripEnabled: auth?.enterpriseFeaturesDto['NON_DOT_TRIP'],
          checkLoadAlertEnabled: auth?.enterpriseFeaturesDto['CHECK_LOAD_ALERT'],
          chartEnabled: auth?.enterpriseFeaturesDto['CHART'],
          advancedDvirEnabled: auth?.enterpriseFeaturesDto['ADVANCED_DVIR'],
          editDrTimeToYmAndPcEnabled: auth?.enterpriseFeaturesDto['EDIT_DR_TIME_TO_YM_AND_PC'],
          udBulkEditEnabled: auth?.enterpriseFeaturesDto['UD_BULK_EDIT'],
          partsInventoryEnabled: auth?.enterpriseFeaturesDto['INVENTORY_PARTS'],
          geometrisEnabled: auth?.enterpriseFeaturesDto['GEOMETRIS'],
          editOilFieldWaitingEnabled: auth?.enterpriseFeaturesDto['EDIT_OIL_FIELD_WAITING'],
          csaViolationFieldWaitingEnabled: auth?.enterpriseFeaturesDto['CSA_VIOLATION'],
          reportsEnabled: auth?.enterpriseFeaturesDto['REPORTS'],
          cycleRuleEnabled: auth?.enterpriseFeaturesDto['CYCLE_RULE'],
          customDvirEnabled: auth?.enterpriseFeaturesDto['CUSTOM_DVIR'],
          cameraIntegrationEnabled: auth?.enterpriseFeaturesDto['CAMERA_INTEGRATION'],
          cameraList: auth?.enterpriseFeaturesDto['CAMERA_INTEGRATION'],
          spireonReportsEnabled: auth?.enterpriseFeaturesDto['SPIREON_REPORTS'],
          dvirOnlyEnabled: auth?.enterpriseFeaturesDto['DVIR_ONLY'],
          dvirOnlyUserEnabled: auth?.enterpriseFeaturesDto['DVIR_ONLY_USER'],
          fleetOpsEnabled: auth?.enterpriseFeaturesDto['FLEETOPS'],
          canadaComplianceEnabled: auth?.enterpriseFeaturesDto['CANADA_COMPLIANCE'],
          cycleRuleUsaEnabled: auth?.enterpriseFeaturesDto['CYCLE_RULE_USA'],
          cycleRuleCanadaEnabled: auth?.enterpriseFeaturesDto['CYCLE_RULE_CANADA'],
          realTimeLogsEnabled: auth?.enterpriseFeaturesDto['REAL_TIME_LOGS'],
          inspectionPdfCanadaEnabled: auth?.enterpriseFeaturesDto['INSPECTION_PDF_CANADA'],
          cycleRuleCaliforniaEnabled: auth?.enterpriseFeaturesDto['CYCLE_RULE_CALIFORNIA'],
          cycleRuleFloridaEnabled: auth?.enterpriseFeaturesDto['CYCLE_RULE_FLORIDA'],
          customPoliciesEnabled: auth?.enterpriseFeaturesDto['CUSTOM_POLICIES'],
          downloadCenterEnabled: auth?.enterpriseFeaturesDto['DOWNLOAD_CENTER'],
          smoothTrackingEnabled: auth?.enterpriseFeaturesDto['SMOOTH_TRACKING'],
          taxableMilesViewEnabled: auth?.enterpriseFeaturesDto['IFTA_UPDATE_CENTER'],
          wDashboard: auth?.enterpriseFeaturesDto['DASHBOARD_WEB'],
          wLogs: auth?.enterpriseFeaturesDto['LOGS_WEB'],
          wUsersList: auth?.enterpriseFeaturesDto['USER_LIST_WEB'],
          wUserDetails: auth?.enterpriseFeaturesDto['USER_DETAILS_WEB'],
          wVehiclesList: auth?.enterpriseFeaturesDto['VEHICLE_LIST_WEB'],
          wVehicleDetails: auth?.enterpriseFeaturesDto['VEHICLE_DETAILS_WEB'],
          wAccidents: auth?.enterpriseFeaturesDto['ACCIDENTS_WEB'],
          wReportAndMaintenance: auth?.enterpriseFeaturesDto['REPAIR_AND_MAINTENANCE_WEB'],
          wInspections: auth?.enterpriseFeaturesDto['INSPECTIONS_WEB'],
          wFuelConsumptionReport: auth?.enterpriseFeaturesDto['FUEL_CONSUMPTION_REPORT_WEB'],
          wIFTAReport: auth?.enterpriseFeaturesDto['IFTA_REPORT_WEB'],
          wPoliciesAndProcedures: auth?.enterpriseFeaturesDto['POLICIES_AND_PROCEDURES_WEB'],
          wCompanyDocuments: auth?.enterpriseFeaturesDto['COMPANY_DOCUMENTS_WEB'],
          wDailyDocuments: auth?.enterpriseFeaturesDto['DAILY_DOCUMENTS_WEB'],
          wMechanicLogin: auth?.enterpriseFeaturesDto['MECHANIC_LOGIN_WEB'],
          wCompanySummary: auth?.enterpriseFeaturesDto['COMPANY_SUMMARY_WEB'],
          wAlerts: auth?.enterpriseFeaturesDto['ALERTS_WEB'],
          wIbeacon: auth?.enterpriseFeaturesDto['IBEACON_WEB'],
          passengerDVIREnabled: auth?.enterpriseFeaturesDto['PASSENGER_DVIR'],
        },
        subscriptions: {
          wDashboard: auth?.enterpriseFeaturesDto['DASHBOARD_WEB'],
          wLogs: auth?.enterpriseFeaturesDto['LOGS_WEB'],
          wUsersList: auth?.enterpriseFeaturesDto['USER_LIST_WEB'],
          wUserDetails: auth?.enterpriseFeaturesDto['USER_DETAILS_WEB'],
          wVehiclesList: auth?.enterpriseFeaturesDto['VEHICLE_LIST_WEB'],
          wVehicleDetails: auth?.enterpriseFeaturesDto['VEHICLE_DETAILS_WEB'],
          wAccidents: auth?.enterpriseFeaturesDto['ACCIDENTS_WEB'],
          wReportAndMaintenance: auth?.enterpriseFeaturesDto['REPAIR_AND_MAINTENANCE_WEB'],
          wInspections: auth?.enterpriseFeaturesDto['INSPECTIONS_WEB'],
          wFuelConsumptionReport: auth?.enterpriseFeaturesDto['FUEL_CONSUMPTION_REPORT_WEB'],
          wIFTAReport: auth?.enterpriseFeaturesDto['IFTA_REPORT_WEB'],
          wPoliciesAndProcedures: auth?.enterpriseFeaturesDto['POLICIES_AND_PROCEDURES_WEB'],
          wCompanyDocuments: auth?.enterpriseFeaturesDto['COMPANY_DOCUMENTS_WEB'],
          wDailyDocuments: auth?.enterpriseFeaturesDto['DAILY_DOCUMENTS_WEB'],
          wMechanicLogin: auth?.enterpriseFeaturesDto['MECHANIC_LOGIN_WEB'],
          wCompanySummary: auth?.enterpriseFeaturesDto['COMPANY_SUMMARY_WEB'],
          wAlerts: auth?.enterpriseFeaturesDto['ALERTS_WEB'],
          wIbeacon: auth?.enterpriseFeaturesDto['IBEACON_WEB'],
        },
      };
    } else {
      return {
        enterpriseFeatureDto: {},
        subscriptions: {},
      };
    }
  };